import React, { useContext } from 'react';
import TextButton from '../../../TextButton';
import { ToastContext } from '../../../Toast/ToastContext';
const ToastLink = ({ dataHook, href, target, onClick, children, }) => {
    const toastHidden = useContext(ToastContext)?.hidden ?? false;
    return (React.createElement(TextButton, { dataHook: dataHook, as: "a", skin: "light", size: "medium", underline: "always", href: href, target: target, onClick: onClick, disabled: toastHidden }, children));
};
export default ToastLink;
//# sourceMappingURL=ToastLink.js.map